import type { PurchaseType } from '../purchases/purchase.enum'

// espelha LogAction do payments-api. gravado como string na coluna 'type'.
export enum LogAction {
    price_adjustment_applied = 'price_adjustment_applied',
    price_adjustment_reverted = 'price_adjustment_reverted',
    charge_refunded = 'charge_refunded',
}

// espelha LogStatus: um log revertido não é apagado, é marcado
export enum LogStatus {
    reverted = 70,
    active = 100,
}

// contexto que o endpoint traz junto do log, por 'select' — não é a parcela inteira
export class LogCharge {
    value: number
    dueDate: Date
    paidAt?: Date
    paymentMethod?: string
    installmentNumber?: number
    installmentTotal?: number
    purchase?: {
        purchaseDescription: string
        referenceId?: string
        purchaseType: PurchaseType
    }
}

export class Log {
    logId: string
    createdAt: Date
    message: string
    data?: any
    type: LogAction
    status: LogStatus
    chargeId?: string
    purchaseId?: string
    charge?: LogCharge
    // preenchido no cliente a partir de charge.purchase.referenceId
    person?: any
}

/**
 * Payload de um estorno (type = charge_refunded). Espelha ChargeRefundData do payments-api.
 *
 * Um registro por evento: estorno parcial é N para 1, então 'amount' é o valor DESTE estorno e
 * 'refundedAfter' é o acumulado da parcela depois dele.
 */
export class ChargeRefundData {
    // 'canceled' = não estava paga, foi invalidada; 'refunded' = estava paga, dinheiro devolvido
    outcome: string
    amount: number
    chargeValue: number
    refundedBefore: number
    refundedAfter: number
    full: boolean
    previousStatus: number
    newStatus: number
    paymentMethod: string
    gatewayId: string
    gatewayReference?: string
}
